import { render, staticRenderFns } from "./error-box.vue?vue&type=template&id=0851d4f9&scoped=true&"
import script from "./error-box.vue?vue&type=script&lang=js&"
export * from "./error-box.vue?vue&type=script&lang=js&"
import style0 from "./error-box.vue?vue&type=style&index=0&id=0851d4f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0851d4f9",
  null
  
)

export default component.exports